import React, {useState} from 'react';
import SelectSvgSelector from './SelectSvgSelector';
import AsyncSelect from 'react-select/async';
import {deliveryAPI} from '../../API/api';
import CustomAsyncSelect from '../Select/CustomAsyncSelect';

type Props = {
	token: string;
	npCityRef: string;
	type: string;
	setFieldValue: any;
	resetTrigger?: number; // Add reset trigger prop
	deliveryType?: string; // Add delivery type to determine API method
};
const OrderAddressSelect = ({
	token,
	npCityRef,
	type,
	setFieldValue,
	resetTrigger,
	deliveryType,
}: Props) => {
	const [value, setValue] = useState({label: '', value: '', ref: ''});

	// Reset internal state when resetTrigger changes
	React.useEffect(() => {
		if (resetTrigger) {
			setValue({label: '', value: '', ref: ''});
		}
	}, [resetTrigger]);

	const loadOptions = async (inputValue: string) => {
		try {
			let response: any;

			// For Nova Poshta warehouses (branches and postomats), use getWarehouses API
			if (deliveryType === 'branch' || deliveryType === 'ware') {
				const warehouseType = deliveryType === 'ware' ? 'postomat' : 'branch';
				response = await deliveryAPI.getWarehousesInNP(
					token ?? '',
					npCityRef,
					warehouseType,
				);

				// Map warehouses response and filter by input if provided
				let warehouses = response?.data?.data || [];

				// Filter warehouses by input text if provided
				if (inputValue && inputValue.trim()) {
					warehouses = warehouses.filter((warehouse: any) =>
						warehouse.Description.toLowerCase().includes(
							inputValue.toLowerCase(),
						),
					);
				}

				const options = warehouses.map((warehouse: any) => ({
					value: warehouse.Ref,
					label: warehouse.Description,
					ref: warehouse.Ref,
				}));

				return options;
			} else {
				// For addresses (streets), use the existing getAddressInNP API
				response = await deliveryAPI.getAddressInNP(
					token ?? '',
					inputValue,
					npCityRef,
					type,
				);

				const options = response?.data?.data?.map((address: any) => ({
					value: address.SiteKey,
					label: address.Description,
					ref: address.Ref,
				}));

				return options || [];
			}
		} catch (error: any) {
			console.error('Error loading options:', error);
			return [];
		}
	};
	const handleChange = (newValue: any) => {
		setValue({
			label: newValue.label,
			value: newValue.value,
			ref: newValue.ref || newValue.Ref,
		});

		setFieldValue('address_ref', newValue.ref || newValue.Ref);
		setFieldValue('address_name', newValue.label);
	};
	return (
		<div>
			<CustomAsyncSelect
				isClearable={false}
				loadOptions={loadOptions}
				cacheOptions
				defaultOptions={true}
				value={value}
				onChange={handleChange}
			/>
		</div>
	);
};
export default OrderAddressSelect;
